module.exports = __webpack_public_path__ + "img/system49-details.d54ba5da.png";